export default {
  confirmarConta: {
    aguarde: "Aguarde, estamos criando a sua conta...",
    falhaAoCarregarDados: "Falha ao criar conta",
    confirmacao:
      "Sua conta está pronta. Você receberá um email para criar sua senha de acesso"
  }
};
